export default __webpack_public_path__ + "static/media/m3.4bc8f92d.png";